(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pullAllWith', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pullAllWith'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pullAllWith, global.convert);
    global.pullAllWith = mod.exports;
  }
})(this, function (exports, _pullAllWith2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pullAllWith = undefined;

  var _pullAllWith3 = _interopRequireDefault(_pullAllWith2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.pullAll} except that it accepts <code>comparator</code> to compare elements.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Array} values The values to remove.
   * @param {Function} [comparator] The comparator invoked per element.
   * @return {Object} Returns the updated object.
   * @example pullAllWith({ nested: { prop: [{ x: 1 }, { x: 2 }, { x: 3 }, { x: 1 }, { x: 2 }, { x: 3 }] } }, 'nested.prop', [{ x: 1 }, { x: 3 }], (a, b) => a.x === b.x) // => { nested: { prop: [{ x: 2 }, { x: 2 }] } }
   * @see {@link https://lodash.com/docs#pullAllWith|lodash.pullAllWith} for more information.
   * @since 0.3.0
   */
  var pullAllWith = (0, _convert.convert)(_pullAllWith3.default);
  exports.pullAllWith = pullAllWith;
  exports.default = pullAllWith;
});